import React, { useEffect, useState } from 'react';
import Entrepreneur from 'src/assets/images/svg/Entrepreneur.svg';
import MentorBadge from 'src/assets/images/svg/MentorBadge.svg';
import IncubatorBadge from 'src/assets/images/svg/IncubatorBadge.svg';
import Company from 'src/assets/images/svg/Company.svg';
import { Button, ConfirmModal, ProfilePicture } from 'src/components/common';
import cx from './ventureCard.module.scss';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useGetIdentity, useUrlParamValue } from 'src/hooks';
import { TFollowRequest, TGetUserStatsRequest, TListOneToOneChatsRequest } from 'src/services/apiEndpoint.types.ts';
import { useNavigate } from 'react-router-dom';
import { follow, getUserStats, unFollow } from 'src/store/socialMedia/socialMedia.slice';

export default function CoFounderCard({ coFounder }: any) {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const { paramValue } = useUrlParamValue();
    const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
    const { getIdentities } = useGetIdentity();
    const { authenticatedId, loggedInUserType } = getIdentities();
    const [isFollowing, setIsFollowing] = useState(false);

    const [show, setShow] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const viewUserProfile = coFounder?.User;
    const viewCompanyProfile = coFounder?.Company;
    const userId = coFounder?.User?.id;
    const companyId = coFounder?.Company?.id;
    const isNoOwner = (loggedInUserType === 'User' ? authenticatedId !== coFounder?.User?.id : authenticatedId !== coFounder?.Company?.id)
    const handleGetUserStats = () => {
        const payload: TGetUserStatsRequest = {
            ...(userId ? { userId } : { userId: companyId }),
            userType: companyId ? 'Company' : 'User',
            requestorId: authenticatedId,
            requestorType: loggedInUserType
        };

        dispatch(getUserStats(payload)).then((res) => {
            setIsFollowing(res?.data?.isFollowing);
        })
    };

    useEffect(() => {
        if (userId || companyId) {
            handleGetUserStats();
        }
    }, [viewUserProfile, viewCompanyProfile]);
    const handleFollow = () => {
        if (!isAuthorized) {
            setShow(true)
            return
        }
        const payload: TFollowRequest = {
            userId: authenticatedId,
            userType: loggedInUserType,
            followUserId: userId || companyId,
            followUserType: companyId ? 'Company' : 'User'
        };
        setLoading(true)
        setTimeout(() => {
            setLoading(false)
        }, 1800)

        if (isFollowing) {
            dispatch(unFollow(payload)).then(() => {
                handleGetUserStats();
            });
        } else {
            dispatch(follow(payload)).then(() => {
                handleGetUserStats();
            });
        }
    };
    function handleNavigate() {
        navigate(`/login?prev=/view-profile?id=${userId}`)
    }

    function handleProfileView() {
        if (companyId) {
            if (authenticatedId === companyId) {
                navigate('/my-company')
            } else {
                navigate(`/view-company?id=${companyId}`)
            }
        } else {
            if (authenticatedId === userId) {
                navigate('/my-profile')
            } else {
                navigate(`/view-profile?id=${userId}`)
            }
        }
    }
    return (
        <>
            <ConfirmModal
                title=""
                description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
                    <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
                    <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
                </p>}
                openConfirmModal={show}
                onClose={() => setShow(false)}
                onSubmit={handleNavigate}
                submitText="Sign in"
                type="confirm"
            />
            <div className={cx.aboutFoundersImage}>
                <ProfilePicture onClick={handleProfileView} url={coFounder?.User?.profilePic || coFounder?.Company?.logo} fallback={coFounder?.User?.name?.[0] || coFounder?.Company?.name?.[0]} />
                <div className={cx.aboutFounderscontent} onClick={handleProfileView}>
                    <h4>{coFounder?.User?.name || coFounder?.Company?.name}</h4>
                    {(coFounder?.User?.role === "Aspiring Entrepreneur" || coFounder?.User?.role === "Entrepreneur") && (<img style={{ marginLeft: "8px", height: "20px", width: "20px", marginBottom: "2px" }} src={Entrepreneur} alt="  Entrepreneur" />)}
                    {(coFounder?.User?.role === "Mentor" || coFounder?.User?.role === "Investor") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={MentorBadge} alt="Mentor/Investor" />)}
                    {(coFounder?.User?.role === "Incubator" || coFounder?.User?.role === "E-Cell" || coFounder?.User?.role === "Accelerator") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={IncubatorBadge} alt="IncubatorBadge" />)}
                    {(coFounder?.User?.role === "Start up" || coFounder?.User?.role === "Service Provider") && (<img style={{ marginLeft: "8px", height: "18px", width: "18px", marginBottom: "2px" }} src={Company} alt="Company" />)}
                    {/* <span>Aspiring Entreprenuer</span> */}
                </div>
                {isNoOwner && (authenticatedId !== companyId || authenticatedId !== userId) && <Button variant={isFollowing ? 'secondary' : 'primary'} disabled={loading} size="extraSmall" onClick={handleFollow}>
                    {isFollowing ? 'Following' : 'Follow'}
                </Button>}
            </div>
            
        </>
    )
}
